const mixin = {
  data() {
      return {
      }
  },
  mounted() {},
  methods: {
    ure(name){ // 拼接是哪个文档
      var arr = ['ppt','doc','docx','xls','zip','rar','txt','pdf','xlsx','pptx']
      var obj = {
        'xls': 'https://qxystatic.qingxiaoyun.com/qingxiaoyun/files/20201028/275d6882566d9e3245fc270e7fe28a3a.png',
        'xlsx': 'https://qxystatic.qingxiaoyun.com/qingxiaoyun/files/20201028/275d6882566d9e3245fc270e7fe28a3a.png',
        'zip': 'https://qxystatic.qingxiaoyun.com/qingxiaoyun/files/20201028/25782a0bc47ec274762fdd5f631e5a3b.png',
        'rar': 'https://qxystatic.qingxiaoyun.com/qingxiaoyun/files/20201028/25782a0bc47ec274762fdd5f631e5a3b.png',
        'ppt': 'https://qxystatic.qingxiaoyun.com/qingxiaoyun/files/20201028/f529863abaf899dab69d3c91225097b5.png',
        'pptx':'https://qxystatic.qingxiaoyun.com/qingxiaoyun/files/20201028/f529863abaf899dab69d3c91225097b5.png',
        'doc': 'https://qxystatic.qingxiaoyun.com/qingxiaoyun/files/20201028/f3b46808016c91f2b598f4672b1220dc.png',
        'docx': 'https://qxystatic.qingxiaoyun.com/qingxiaoyun/files/20201028/f3b46808016c91f2b598f4672b1220dc.png',
        'txt': 'https://qxystatic.qingxiaoyun.com/qingxiaoyun/files/20201028/2904a033f7093beef8e2a992761e840e.png',
        'pdf':'https://qxystatic.qingxiaoyun.com/qingxiaoyun/files/20201028/2d3ece761e8f4a1fd5b0775f55c9f225.png',
        'file':'https://qxystatic.qingxiaoyun.com/qingxiaoyun/files/20201028/b7a75c3257fac1e9edfa426f01bd4645.png',
      }
      try {
        var n =name.split('.')[1];
        if (!arr.includes(n)) {
            n = 'file'
        }
        return obj[n]
      } catch (error) {
        return obj['file']
      }

      // return `@/assets/images/${n}.png`
    },
    sname(name) { 
      try {
        var n = name.split('.')[0];
        return n
      } catch (error) {
        return ''
      }

    }
  }
};
export default mixin;